module.exports = __webpack_public_path__ + "img/featured-mobile-cta-3.cd027efe.jpg";